export default "__VITE_ASSET__5z9L4n_B__"